import { render } from "./borderRadius.vue?vue&type=template&id=687060d8"
import script from "./borderRadius.vue?vue&type=script&lang=js"
export * from "./borderRadius.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__